(function () {
  'use strict';

  function initInstance(root) {
    var track = root.querySelector('[data-splans-track]');
    var dotsWrap = root.querySelector('[data-splans-dots]');
    if (!track || !dotsWrap) return;

    var cards = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(dotsWrap.children);
    if (!cards.length || !dots.length) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var card = cards[i];
        if (!card) return;
        track.scrollTo({
          left: card.offsetLeft - track.offsetLeft,
          behavior: 'smooth',
        });
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var index = cards.indexOf(entry.target);
              if (index > -1) setActive(index);
            }
          });
        },
        { root: track, threshold: 0.6 }
      );

      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    setActive(0);
  }

  function initAll() {
    document.querySelectorAll('[data-splans]').forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-splans]');
    if (root) initInstance(root);
  });
})();
